<template>
  <div class="row">
    <div class="col-12 text-center">
      <img src="./../assets/loading.gif" alt="" class="loading">
      <br>
      <span class="text-muted">Loading...</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading'
}
</script>
<style lang="scss" scoped>
img{
  height: 30px;
  margin: 100px 100px 20px 100px;
}
span{
  margin-bottom: 80px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue